import React from 'react';
import Button from '@mui/material/Button';
import { useUiLanguageStore } from '../../store/uiLanguageStore';

export const LanguageToggle: React.FC<{ size?: 'small' | 'medium' | 'large' }> = ({ size = 'small' }) => {
  const { locale, toggle } = useUiLanguageStore();
  const next = locale === 'ar' ? 'EN' : 'AR';
  return (
    <Button
      onClick={toggle}
      size={size}
      variant="outlined"
      aria-label={`Switch to ${next}`}
      sx={{ minWidth: 56, fontWeight: 600 }}
    >
      {next}
    </Button>
  );
};
